<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 7 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.327329 12.0893C0.00189281 11.7639 0.00189281 11.2362 0.327329 10.9108L4.73807 6.50004L0.327329 2.0893C0.00189281 1.76386 0.00189281 1.23622 0.327329 0.910786C0.652766 0.585348 1.1804 0.585348 1.50584 0.910786L6.80047 6.20541C6.96319 6.36813 6.96319 6.63195 6.80047 6.79467L1.50584 12.0893C1.1804 12.4147 0.652766 12.4147 0.327329 12.0893Z"
      fill="currentColor"
    />
  </svg>
</template>